class GwtGetNotified extends HTMLElement {
      constructor() {
        super();
        this.form = null;
        this.emailInput = null;
        this.productSelect = null;
        this.submitButton = null;
        this.messageContainer = null;
        this.emailError = null;
        this.isSubmitting = false;
      }

      connectedCallback() {
        this.form = this.querySelector('[data-notify-form]');
        this.emailInput = this.form.querySelector('input[type="email"]');
        this.productSelect = this.form.querySelector('input[name="product_sku"]');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.messageContainer = this.querySelector('.gwt-notify-form-message');

        this.setupEventListeners();
      }

      setupEventListeners() {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      async handleSubmit(event) {
        event.preventDefault();

        if (this.isSubmitting) return;

        this.isSubmitting = true;
        this.setSubmittingState(true);
        this.hideMessage();

        const formData = new FormData(this.form);
        const data = {
          email: formData.get('email'),
          product_sku: formData.get('product_sku') || ''
        };

        const serverUrl = 'https://automations.greenworkstools.ca/webhook/ai-robot-product-subscribe';

        if (!serverUrl) {
          this.showMessage('Server URL not configured', 'error');
          this.setSubmittingState(false);
          this.isSubmitting = false;
          return;
        }

        try {
          const response = await fetch(serverUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(data)
          });

          if (response.ok) {
            this.showMessage('Thank you! You have been added to the notification list.', 'success');
            this.form.reset();
            if (this.emailInput) {
              this.emailInput.focus();
            }
          } else {
            const errorData = await response.json().catch(() => ({}));
            const errorMessage = errorData.message || 'Something went wrong. Please try again.';
            this.showMessage(errorMessage, 'error');
          }
        } catch (error) {
          this.showMessage('Network error. Please check your connection and try again.', 'error');
        } finally {
          this.setSubmittingState(false);
          this.isSubmitting = false;
        }
      }

      setSubmittingState(isSubmitting) {
        const buttonText = this.submitButton.querySelector('.button-text');
      }

      showMessage(message, type) {
        this.messageContainer.textContent = message;
        this.messageContainer.className = 'gwt-notify-form-message ' + type;
        this.messageContainer.setAttribute('role', type === 'error' ? 'alert' : 'status');
      }

      hideMessage() {
        this.messageContainer.textContent = '';
        this.messageContainer.className = 'gwt-notify-form-message';
      }
    }

    customElements.define('gwt-get-notified', GwtGetNotified);